import {Style, Fill, Stroke, Icon, Text} from 'ol/style.js';
import {transformExtent} from 'ol/proj';
import {GeoJsonLayer} from '../GeoJsonLayer.js';
import Library from '../Library.js';

export class AirportLayer extends GeoJsonLayer {
    icon_cache = {};

    constructor( map, settings = {}){
        settings["name"] = 'airport';
        settings["api_endpt"] = "AirportJSON.php";
        if( settings['icon'] == undefined ) settings["icon"] = "full";
        if( settings['labels'] == undefined ) settings["labels"] = false;
        if( settings['scale'] == undefined ) settings["scale"] = 1;
        super( map, settings );
    }

    getUrl( extent, resolution, projection ){
        let extent1 = transformExtent(extent, projection, "EPSG:4326");
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "bbox", extent1.join(","));
        url.searchParams.set( "zoom", this.map.view.getZoom());
        return url.toString();
    }

    getIconSize( feature ){
        return this.settings['scale']*20;
    }

    getIcon( feature ){
        let params = "";
        let color = "803050";
        if( this.property(feature,'tower') == "T" )
            color = "104090";
        let url = this.icon_path+"/wxicon.php?scale="+this.settings['scale'];
        if( this.settings['icon'] == "simple" || this.settings['icon'] == 1 )
            return url + "&code=ARP&color="+color;
        var rwy_hard = false;
        if( this.property(feature,'rwy_type') == "C" ||
                this.property(feature,'rwy_type') == "A" ||
                this.property(feature,'rwy_type') == "H" )
            rwy_hard = true;

        if( this.property(feature,'rwy_length') == "L" &&
                this.property(feature,'runways').length > 1 )
            return url+"&code=ARP-L2B&color="+color;
        if( this.property(feature,'rwy_length') == "L" &&
                this.property(feature,'runways').length == 1 )
            return url+"&code=ARP-L1B&color="+color;
        if( rwy_hard && this.property(feature,'rwy_length') == "M" &&
                this.property(feature,'runways').length > 1 &&
                this.property(feature,'services') == "S" &&
                this.property(feature,'beacon') == "B" )
            return url+"&code=ARP-M2SB&color="+color;
        if( rwy_hard && this.property(feature,'rwy_length') == "M" &&
                this.property(feature,'runways').length > 1 &&
                this.property(feature,'beacon') == "B" )
            return url+"&code=ARP-M2B&color="+color;
        if( rwy_hard && this.property(feature,'rwy_length') == "M" &&
                this.property(feature,'runways').length > 1 &&
                this.property(feature,'services') == "S" )
            return url+"&code=ARP-M2S&color="+color;
        if( rwy_hard && this.property(feature,'rwy_length') == "M" &&
                this.property(feature,'runways').length > 1 )
            return url+"&code=ARP-M2&color="+color;
        if( rwy_hard && this.property(feature,'rwy_length') == "M" &&
                this.property(feature,'runways').length == 1 &&
                this.property(feature,'services') == "S" &&
                this.property(feature,'beacon') == "B" )
            return url+"&code=ARP-M1SB&color="+color;
        if( rwy_hard && this.property(feature,'rwy_length') == "M" &&
                this.property(feature,'runways').length == 1 &&
                this.property(feature,'beacon') == "B" )
            return url+"&code=ARP-M1B&color="+color;
        if( rwy_hard && this.property(feature,'rwy_length') == "M" &&
                this.property(feature,'runways').length == 1 &&
                this.property(feature,'services') == "S" )
            return url+"&code=ARP-M1S&color="+color;
        if( rwy_hard && this.property(feature,'rwy_length') == "M" &&
                this.property(feature,'runways').length == 1 )
            return url+"&code=ARP-M1&color="+color;
        if( this.property(feature,'type') == "ARP" &&
                this.property(feature,'use') == "R" )
            return url+"&code=ARP-R&color="+color;
        if( this.property(feature,'type') == "ARP" )
            return url+"&code=ARP-S&color="+color;
        return url+"&code="+this.property(feature,'type')+"&color="+color;
    }

    getLabel( feature ){
        let str = "";
        if( this.settings['labels'] == true ){
            str = this.property(feature,'id');
            if( str == "-" ) str = this.property(feature,'iata');
        }
        return str;
    }

    getPopupText( feature ){
        let id = this.property(feature,'id');
        if( id == "-" ) id = this.property(feature,'iata');
        let text = this.popupTitle( "AIRPORT", id );
        if( this.property(feature,'iata') != undefined )
            text += this.popupData( "IATA/FAA", this.property(feature,'iata'));
        var type = "Airport";
        if( this.property(feature,'type') == "HEL" )
            type = "Heliport";
        if( this.property(feature,'type') == "SEA" )
            type = "Seaplane";
        if( this.property(feature,'type') == "GLD" )
            type = "Gliderport";
        text += this.popupData( "Type", type );
        text += this.popupData( "Name", this.property(feature,'name'));
        text += this.popupData( "State", this.property(feature,'state'));
        text += this.popupData( "Region/Cntry", this.property(feature,'region'));
        var elev = Math.round(this.property(feature,'elev') * 3.28);
        text += this.popupData( "Elev", elev+"ft / "+this.property(feature,'elev')+"m");
        text += this.popupData( "Mag Dec", this.property(feature,'mag_dev'));
        if( this.property(feature,'use') == "P" )
            text += this.popupData( "Use", "public");
        else if( this.property(feature,'use') == "M" )
            text += this.popupData( "Use", "military");
        else
            text += this.popupData( "Use", "private");
        text += this.popupData( "Runways", this.property(feature,'runways').length);
        if( this.property(feature,'rwy_length') == "L" )
            text += this.popupData( "Runway length", "long (&ge; 8070 feet)" );
        else if( this.property(feature,'rwy_length') == "M" )
            text += this.popupData( "Runway length", "medium (1500 to 8069 feet)" );
        else
            text += this.popupData( "Runway length", "short (&lt; 1500 feet)" );
        if( this.property(feature,'rwy_type') == "H" )
            text += this.popupData( "Runway type", "hard surface" );
        else if( this.property(feature,'rwy_type') == "C" )
            text += this.popupData( "Runway type", "concrete" );
        else if( this.property(feature,'rwy_type') == "A" )
            text += this.popupData( "Runway type", "asphalt" );
        else if( this.property(feature,'rwy_type') == "T" )
            text += this.popupData( "Runway type", "turf" );
        else if( this.property(feature,'rwy_type') == "G" )
            text += this.popupData( "Runway type", "gravel" );
        if( this.property(feature,'services') == "S" )
            text += this.popupData( "Services", "yes, attended" );
        else if( this.property(feature,'services') == "s" )
            text += this.popupData( "Services", "yes, unattended" );
        else
            text += this.popupData( "Services", "none/unknown" );
        if( this.property(feature,'tower') == "T" )
            text += this.popupData( "Towe", "yes" );
        else
            text += this.popupData( "Tower", "no" );
        if( this.property(feature,'beacon') == "B" )
            text += this.popupData( "Beacon", "sunset-sunrise" );
        else
            text += this.popupData( "Beacon", "no" );
        if( this.property(feature,'passengers') > 0 )
            text += this.popupData( "Passengers", this.property(feature,'passengers')/1000.+" million" );
        if( this.property(feature,'runways') != undefined ){
            var rwys = this.property(feature,'runways');
            text += this.popupData( "Runways details", "" );
            text += "<table class='table table-sm table-bordered'>";
            text = text + "<tr class='table-active'><th>Name</th><th style='font-size:10px'>LengthxWidth</th><th style='font-size:10px'>Type</th></tr>";
            for( j = 0; j < rwys.length; j++ ){
                text = text + "<tr class='table-info'><td style='font-size:10px'>"+rwys[j].id + "</td>";
                text = text + "<td style='font-size:10px'>"+rwys[j].dimension + "</td>";
                text = text + "<td style='font-size:10px'>"+rwys[j].surface + "</td></tr>";
            }
            text = text + "</table>";
        }
        if( this.property(feature,'frequencies') != undefined ){
            var freqs = this.property(feature,'frequencies');
            text += this.popupData( "Frequencies", "" );
            text = text + "<table class='table table-sm table-bordered'>";
            for( var j = 0; j < freqs.length; j++ ){
                text = text + "<tr class='table-info'><td style='font-size:10px'>" + freqs[j].type + "</td>";
                text = text + "<td style='font-size:10px'>" + freqs[j].freq+"</td></tr>";
            }
            text = text + "</table>";
        }

        text += this.popupEnd();
        return text;
    }

    getStyle(feature, resolution ){
        let size = this.getIconSize(feature);
        let icon;
        if( this.icon_cache[feature.getId()] )
            icon = this.icon_cache[feature.getId()];
        else {
            icon = new Icon({
                    "src": this.getIcon(feature),
                    "imgSize": [size,size]
                    });
            this.icon_cache[feature.getId()] = icon;
        }
        let style = new Style({
                "image": icon,
                "text": new Text({
                        "font": "12px",
                        "fill": new Fill({
                                "color": "black"
                                }),
                        "text": this.getLabel(feature),
                        "stroke": new Stroke({"color": "white", "width": 2 }),
                        "offsetX": -20,
                        "offsetY": 12
                        })
                });
        return style;
    }

}
